import {parse_int} from '../../../Helpers/js/simple.functions';
import $ from 'jquery';
import LP from '../0-lp';
import UI from '../0-ui';

// =============== //
// MATRIX QUESTION //
// =============== //
LP.matrixQuestion = {
    dispatching: false,

    onLoad: function () {
        var tabname = LP.Dialog.getTabName();

        switch (tabname) {
            case 'cols'            :
                LP.matrixQuestion.colsTab.initEvents();
                break;
            case 'advanced'        :
                LP.matrixQuestion.advTab.initEvents();
                break;
            case 'codes'        :
                LP.questionTab.codes.initEvents();
                break;
        }
    },

    initNonAjaxTabs: function () {
        LP.matrixQuestion.rowsTab.initEvents();
    },

    rowsTab: {
        initEvents: function (root) {
            if (!root) root = $('#rowGroups');

            $('a[action="addRowGroup"]', root).click(function () {
                LP.dlgQuestion.addGroupHere($('#newGroup'), this.parentNode.parentNode, LP.matrixQuestion.rowsTab.initEvents);
            });
            //LP.UI.initButtonMenu({selector:$('.lp-menubar-rowgroups', root), name:'groupMenu'});
            $('a[action="deleteRowGroup"]', root).click(function () {
                LP.dlgQuestion.deleteGroup(this, LP.matrixQuestion.rowsTab.checkRows);
            });

            $('a[action="addRow"]', root).click(function () {
                LP.dlgQuestion.addOptionHere($('#newGroup'), this.parentNode, LP.matrixQuestion.rowsTab.initEvents);
            });
            $('a[action="editLeftInput"]', root).click(function () {
                LP.dlgQuestion.editInput($('input[name="question[leftText][]"]', this.parentNode), this);
            });
            $('a[action="editRightInput"]', root).click(function () {
                LP.dlgQuestion.editInput($('input[name="question[rightText][]"]', this.parentNode), this);
            });
            //LP.UI.initButtonMenu({selector:$('.lp-menubar-rowoptions', root), name:'rowMenu'});
            $('a[action="deleteRow"]', root).click(function () {
                LP.dlgQuestion.deleteOption(this, LP.matrixQuestion.rowsTab.checkRows);
            });

            $('a[action="toggleAddMultiple"]', root).click(LP.matrixQuestion.rowsTab.toggleAddMultiple);
            $('a[action="addMultiple"]', root).click(LP.matrixQuestion.rowsTab.addMultiple);

            $('a[action="toggleInputType"]', root).click(LP.matrixQuestion.toggleInputType);
            $('a[action="toggleFixPos"]', root).click(LP.dlgQuestion.toggleFixPos);

            UI.Slider.init('.lp-slider-preview', 0, 0, 1, 100, 50, '', '', 1, 20, 0);
            $('.lp-slider-preview').slider({disabled: true});

            LP.matrixQuestion.rowsTab.checkRows();
        },

        checkRows: function () {
            if (LP.matrixQuestion.dispatching) return; else LP.matrixQuestion.dispatching = true;
            var groups = $('#rowGroups');
            if ($('fieldset', groups).length === 0) LP.dlgQuestion.addGroup($('#newGroup'), groups, LP.matrixQuestion.rowsTab.initEvents);
            groups.children().each(function (index, group) {
                if ($('li', group).length === 0) {
                    LP.dlgQuestion.addOption($('#newGroup'), $('ul', group), LP.matrixQuestion.rowsTab.initEvents);
                }
            });

            LP.dlgQuestion.setPositions('.groupnum', 'row');
            LP.matrixQuestion.dispatching = false;
        },

        toggleAddMultiple: function () {
            var $this = $(this);
            var $area = $this.siblings('textarea');
            var $button = $area.siblings('a[action="addMultiple"]');

            if ($area.is(':visible')) {
                $area.fadeOut('fast');
                $button.fadeOut('fast');
            } else {
                $area.fadeIn('fast');
                $button.fadeIn('fast');
            }
        },

        addMultiple: function () {
            var $this = $(this);
            var $area = $this.siblings('textarea');
            var options = $area.val();
            var $last = $this.siblings('ul').find('li').last();
            if ($last.length == 0) return;

            if (options != '') {
                var whichSide = 'left',
                    leftLength = $last.find('input[name="question[leftText][]"]').val().length,
                    rightLength = $last.find('input[name="question[rightText][]"]').val().length;
                if ($last.length > 0 && leftLength == 0 && rightLength > 0) {
                    whichSide = 'right';
                }

                var optionArray = options.split(/[\r\n]+/); // split by newlines (and filter empty rows)
                optionArray.forEach(function (option) {
                    if (option.trim() == '') return; // ignore empty lines

                    LP.dlgQuestion.addOptionHere($('#newGroup'), $last, function (element) {
                        var $element = $(element);
                        $element.find('input[name="question[' + whichSide + 'Text][]"]').val(option.trim());

                        $last = $element;
                    });
                });
                LP.matrixQuestion.rowsTab.initEvents($('.lp-answer-list'));
            }

            // and now we clean and close the input again
            $area.val('');
            LP.matrixQuestion.rowsTab.toggleAddMultiple.call(this);
        }
    },

    colsTab: {
        initEvents: function (root) {
            var matrixScales = $('#matrixScales');
            if (!root) root = matrixScales;
            var parent = root.find('fieldset');

            $('a[action="addScale"]', root).click(function () {
                LP.dlgQuestion.addGroupHere($('#newScale'), this.parentNode.parentNode, LP.matrixQuestion.colsTab.initEvents);
            });
            LP.UI.initButtonMenu({selector: $('.lp-menubar-scales', parent), name: 'scaleMenu'});
            $('a[action="editScaleHeadline"]', root).click(function () {
                LP.dlgQuestion.editInput($('input[name="question[headlines][]"]', this.parentNode.parentNode), this);
            });
            $('a[action="deleteScale"]', root).click(function () {
                LP.dlgQuestion.deleteGroup(this, LP.matrixQuestion.colsTab.checkCols);
            });

            $('a[action="addCol"]', root).click(function () {
                LP.dlgQuestion.addOptionHere($('#newScale'), this.parentNode, LP.matrixQuestion.colsTab.initEvents);
            });
            $('a[action="editColText"]', root).click(function () {
                LP.dlgQuestion.editInput($('input[name="question[colText][]"]', this.parentNode.parentNode), this);
            });
            LP.UI.initButtonMenu({selector: $('.lp-menubar-coloptions', root), name: 'colMenu'});
            $('a[action="deleteCol"]', root).click(function () {
                LP.dlgQuestion.deleteOption(this, LP.matrixQuestion.colsTab.checkCols);
            });

            $('a[action="toggleFixPos"]', root).click(LP.dlgQuestion.toggleFixPos);

            $('a[action="preSelectOption"]', root).click(LP.matrixQuestion.colsTab.preSelectOption);

            $('.lp-scale-type', parent).on("change", function () {
                const that = this;
                LP.matrixQuestion.colsTab.onChangeType(that);
            });

            $('.lp-spinbox', matrixScales).each(function (index, element) {
                UI.setupSpinbox($('input', element), -9999, 9999, $('input', element).val(), 1, true, null, true, false, false);
            });

            var typeSelect = $('.lp-scale-type', parent);
            if (typeSelect.length > 0) {
                var scaleType = typeSelect.val();
                if (scaleType === 'SINGLECHOICE' || scaleType === 'MULTICHOICE' || scaleType === 'DROPDOWN') {
                    if (scaleType !== 'DROPDOWN') {
                        $('a[action="preSelectOption"]', root).show();
                    } else {
                        $('a[action="preSelectOption"]', root).hide();
                    }
                    $('.preselect_CHOICE', root).show();
                    $('.lp-scale-points', root).show();
                } else {
                    $('a[action="preSelectOption"]', root).hide();
                    $('.preselect_CHOICE', root).hide();
                    $('.lp-scale-points', root).hide();
                }
            }

            $('a.visibilityItem', root).each(function (index, item) {
                LP.questionTab.itemVisibility.prepare(item);
            });

            LP.matrixQuestion.colsTab.checkCols();
        },

        checkCols: function () {
            if (LP.matrixQuestion.dispatching) return; else LP.matrixQuestion.dispatching = true;
            var scales = $('#matrixScales');

            if ($('fieldset', scales).length === 0) LP.dlgQuestion.addGroup($('#newScale'), scales, LP.matrixQuestion.colsTab.initEvents);
            scales.children().each(function (index, scale) {
                if ($('li', scale).length === 0) LP.dlgQuestion.addOption($('#newScale'), $('ul', scale), LP.matrixQuestion.colsTab.initEvents);
            });
            LP.dlgQuestion.setPositions('.colgroupnum', 'scale');
            LP.matrixQuestion.colsTab.setPositions();
            LP.matrixQuestion.colsTab.updatePreviewTypes();
            LP.matrixQuestion.dispatching = false;
        },

        setPositions: function () {
            var colNum = 1;
            var scales = $('#matrixScales');

            $('ul', scales).each(function (scaleIndex, scale) {
                scale = $(scale);
                $('li', scale).each(function (colIndex, col) {
                    col = $(col);
                    $('.colnum', col).html(colNum++);
                    $('.colscale', col).val(scaleIndex);
                    $('.colpos', col).val(colIndex);
                });
            });
        },

        onChangeType: function (that) {
            var select = $(that);
            var field = select.closest('fieldset');
            var scalenum = $('.colgroupnum', field).html();
            var scaleindex = parse_int(scalenum);

            $('a[action="preSelectOption"]', field).hide(); // hide all preselection
            $('.colpreselected', field).val(''); // clear all preselection
            $('.preselect_CHOICE', field).removeClass('icon-check-2').removeClass('icon-check-empty').addClass('icon-check-empty'); // reset other

            if (select.val() === 'SINGLECHOICE' || select.val() === 'MULTICHOICE' || select.val() === 'DROPDOWN') {
                $('.preselect_CHOICE', field).show();
            } else if (select.val() === 'TEXTFIELD') {
                $('.preselect_TEXT', field).show();
            }
            // eslint-disable-next-line no-dupe-else-if
            else if (select.val() === 'TEXTFIELD') {
                $('.preselect_VALUE', field).show();
            }

            if (select.val() === 'TEXTFIELD' || select.val() === 'SLIDER') {
                $('.lp-scale-points ', field).hide();
            } else {
                $('.lp-scale-points ', field).fadeIn();
            }

            if (scaleindex >= 1 && scaleindex <= 4) {
                LP.matrixQuestion.colsTab.updatePreviewTypes();
            }
        },

        preSelectOption: function () {
            var scale = $(this).closest('fieldset');
            var scaleType = $('.lp-scale-type', scale).val();
            var item = $(this);
            var input = $('.colpreselected', item.closest('li'));
            var state = input.val();

            switch (scaleType) {
                case 'SINGLECHOICE' :
                case 'DROPDOWN':
                    // Only One Allowed
                    $('.preselect_CHOICE', scale).removeClass('icon-check-2').removeClass('icon-check-empty').addClass('icon-check-empty'); // reset other
                    $('.colpreselected', scale).val(''); // clear other
                    item.removeClass('icon-check-empty').addClass(state === '1' ? 'icon-check-empty' : 'icon-check-2');
                    input.val(state === '1' ? '0' : '1');
                    break;

                case 'MULTICHOICE' :
                    // Multiple allowed
                    item.removeClass('icon-check-empty').removeClass('icon-check-2').addClass(state === '1' ? 'icon-check-empty' : 'icon-check-2');
                    input.val(state === '1' ? '0' : '1');
                    break;
                case 'SLIDER' :
                    break;
                case 'TEXTFIELD' :
                    break;
            }
        },

        updatePreviewTypes: function () {
            var matrixScales = $('#matrixScales');
            var scaleTypes = new Array();

            var numMatrixScales = 0;
            $('.lp-scale-type', matrixScales).each(function (index, scale) {
                scaleTypes.push($(scale).val());
                numMatrixScales++;
            });

            var numPreviews = 4;
            var previewHTML = '';
            if (numMatrixScales === 1) {
                previewHTML += LP.matrixQuestion.colsTab.makePreviewInput(scaleTypes[0]);
                previewHTML += LP.matrixQuestion.colsTab.makePreviewInput(scaleTypes[0]);
            } else if (numMatrixScales === 2) {
                previewHTML += LP.matrixQuestion.colsTab.makePreviewInput(scaleTypes[0]);
                previewHTML += LP.matrixQuestion.colsTab.makePreviewInput(scaleTypes[1]);
            } else {
                var usedCols = 0;
                for (var i = 0; i < scaleTypes.length; i++) {
                    if (usedCols < numPreviews) {
                        usedCols += LP.matrixQuestion.colsTab.getPreviewColSpan(scaleTypes[i]);
                        previewHTML += LP.matrixQuestion.colsTab.makePreviewInput(scaleTypes[i]);
                    }
                }
            }

            var previewDiv = $('.lp-scale-preview');
            previewDiv.html(previewHTML);
        },

        getPreviewColSpan: function (scaleType) {
            switch (scaleType) {
                case 'SINGLECHOICE':
                    return 2;
                case 'MULTICHOICE':
                    return 2;
                case 'DROPDOWN':
                    return 2;
                case 'TEXTFIELD':
                    return 1;
                case 'SLIDER':
                    return 1;
            }
            return 0;
        },

        makePreviewInput: function (scaleType) {
            var numPreviewCols = LP.matrixQuestion.colsTab.getPreviewColSpan(scaleType);

            var previewHtml = '';
            var previewWidth = '';

            for (var i = 0; i < numPreviewCols; i++) {
                var addClass = '';
                var inputType = '';
                var inputClass = '';
                switch (scaleType) {
                    case 'SINGLECHOICE':
                        inputType = 'radio';
                        addClass = 'pad-t-5';
                        break;
                    case 'MULTICHOICE':
                        inputType = 'checkbox';
                        addClass = 'pad-t-5';
                        break;
                    case 'DROPDOWN':
                        inputType = 'text';
                        inputClass = 'hgt-15';
                        addClass = 'pad-t-5 pad-r-5';
                        break;
                    case 'TEXTFIELD':
                        inputType = 'text';
                        inputClass = 'hgt-15';
                        addClass = 'pad-t-5 pad-r-5';
                        break;
                    case 'SLIDER':
                        inputType = 'text';
                        inputClass = 'hgt-15';
                        addClass = 'pad-t-5 pad-r-5';
                        break;
                }
                previewHtml += '<div class="in-block ' + previewWidth + ' ' + addClass + '">';
                previewHtml += '<input type="' + inputType + '" class="' + inputClass + '" disabled="1" size="1" />';
                previewHtml += '</div>';
            }
            return previewHtml;
        }
    },

    advTab: {
        initEvents: function (root) {
            if (!root) root = $('body');
            $('a[action="editTextBefore"]', root).button().click(function () {
                LP.dlgQuestion.editInput($('input', this.parentNode), this);
            });
            $('a[action="editTextAfter"]', root).button().click(function () {
                LP.dlgQuestion.editInput($('input', this.parentNode), this);
            });

            $('.repColTextRadio', root).click(LP.matrixQuestion.advTab.switchColTextPosArea);

            var minAnsweredRows = $('#minAnsweredRows');
            var maxAnsweredRows = $('#maxAnsweredRows');

            UI.setupSpinbox(minAnsweredRows, 1, 5000, minAnsweredRows.val(), 1, false, 0, true, false, false);
            UI.setupSpinbox(maxAnsweredRows, 1, 5000, maxAnsweredRows.val(), 1, false, 0, true, false, false);

            $('.lp-fs-matrixAdvance .lp-spinbox').each(function (index, element) {
                UI.setupSpinbox($('input', element), -9999, 9999, $('input', element).val(), 1, true, null, true, false, false);
            });

        },

        switchColTextPosArea: function () {
            if (this.value === '1') {
                $('#colTextPosition').fadeIn('fast');
            } else {
                $('#colTextPosition').fadeOut('fast');
            }
        }
    },

    toggleInputType: function () {
        var $this = $(this);
        if ($this.is('[disabled]')) return false;
        var $input = $('input', $this.parent());
        var hasinput = $input.attr('value') !== '1';
        $input.attr('value', hasinput ? 1 : 0);
        $this.toggleClass('icon-edit', !hasinput);
        $this.toggleClass('icon-ok', hasinput);
    }
};
